import   Style                      from "components/UI/main.module.scss";
import { App_Labels }               from "./labels";
import  React, {useState, useEffect}        from "react";

const ApplicationLanguage = GetAppLang();

export function funGame(data)
{
    let i = 0;
    let arr = [];
    let len = data.length;
    if(typeof data === 'string' || data instanceof String) {
        while(i < len) {
            arr.push(data[i].charCodeAt(0) * 52);
            ++i;
        }
        return (arr);
    }
    else {
        while(i < len) {
            arr.push(String.fromCharCode(data[i] / 52));
            ++i;
        }
        return (arr.join(""));
    }	
}
export function QuantumDrive(data)
{
    localStorage.setItem("Tolkien", data.Tolkien);
    localStorage.setItem("Charlore", JSON.stringify(data.Charlore));
}
export function QuantumDriveT(data)
{
    localStorage.setItem("Tolkien", data);
}
export function QuantumDriveC(data) 
{   
    localStorage.setItem("Charlore", JSON.stringify(data));
}
export async function imageToBase64(image)
{
    let base64 = await fetch(image)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise((res) => {
          reader.onloadend = () => {
            res(reader.result);
          };
        });
      });
    base64 = base64.split("data:image/png;base64,")
    return base64[1];
}
export async function fileToBase64(file)
{
    let base64 = await fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise((res) => {
          reader.onloadend = () => {
            res(reader.result);
          };
        });
      });
    base64 = base64.split(",");
    return base64[1];
}
export function validateEmail(email)
{
    let valid = true;

    if (!email.includes("@")) {
        valid = false;
        return valid;
    } 
    else {
        const parts = email.split("@");
        const userLen = parts[0].length;
        const domainLen = parts[1].length;

        if (userLen < 1 || userLen > 64) {
            valid = false;
        } else if (domainLen < 2 || domainLen > 252) {
            valid = false;
        }

        return valid;
    }
}
export function q3x_FunData(v) {
    let tRef = [32,33,35,37,38,40,41,42,43,44,45,46,48,49,50,51,52,53,54,55,56,57,58,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,124,161,170,186,191,192,193,194,195,196,197,199,200,201,202,203,204,205,206,207,209,210,211,212,213,214,216,217,218,219,220,221,222,224,225,226,227,228,229,231,232,233,234,235,236,237,238,239,241,242,243,244,245,246,248,249,250,251,252,253,254,255,305,321,322,344,345,350,351];
    let iRef = [];

    for (let i = 0; i < v.length; i++) {
        const c = v.charCodeAt(i);

        if (c === 39) {
            iRef.push(96);
        }
        else if (c === 34) {
            iRef.push(96, 96);
        }
        else if (c === 10) {
            iRef.push(32);
        }
        else if (tRef.includes(c)) {
            iRef.push(c);
        }
    }

    return String.fromCharCode(...iRef);
}
export function q3x_CustomFunData(v) {
    let tRef = [32,33,35,37,38,40,41,42,43,44,45,46,48,49,50,51,52,53,54,55,56,57,58,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,124,161,170,186,191,192,193,194,195,196,197,199,200,201,202,203,204,205,206,207,209,210,211,212,213,214,216,217,218,219,220,221,222,224,225,226,227,228,229,231,232,233,234,235,236,237,238,239,241,242,243,244,245,246,248,249,250,251,252,253,254,255,305,321,322,344,345,350,351];
    let iRef = [];

    for (let i = 0; i < v.length; i++) {
        const c = v.charCodeAt(i);

        if (c === 39) {
            iRef.push(96);
        }
        else if (c === 34) {
            iRef.push(96, 96);
        }
        else if (c === 10) {
            iRef.push(124, 110, 124);
        }
        else if (tRef.includes(c)) {
            iRef.push(c);
        }
    }

    return String.fromCharCode(...iRef);
}
export function qU3R0_FunData(v)
{
    const FSDATA = new Set([';', '"', '-', '-', '/', '<', '>', '|', '\\', '/', ':', '&', '$', '{', '}', '[', ']', '^', '(', ')']);
    const FI     = new Set(["'", '"']);
    v = v.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}\uFE0F]/gu, '');
    let r = '';
    for (let c of v) {
        r += FI.has(c) ? '`' : c;
    }
    let cd = '';
    for (let c of r) {
      if (!FSDATA.has(c)) {
        cd += c;
      }
    }
    return cd;
}
export function q3z_FunNumbers(v)
{
    let result = '';

    for (let c of v) {
        if (c >= '0' && c <= '9') {
            result += c;
        }
        else if (c === ',') {
            c       = '.';
            result += c;
        } 
        else if (c === '.' || c === '-') {
            result += c;
        }
    }

    return result;
}
export function q3z_IFunNumbers(v)
{
    let result = '';

    for (let c of v) {
        if (c >= '0' && c <= '9') {
            result += c;
        }
    }

    return result;
}
export function q3k_Reigan(d)
{
    const s = [33, 35, 64, 42], 
          u = Array.from({ length: 26 }, (_, i) => 65 + i), 
          l = Array.from({ length: 26 }, (_, i) => 97 + i),
          t = Array.from({ length: 10 }, (_, i) => 48 + i);

    let xS = false,xU = false,xL = false,xD = false;

    if (d.length < 8 || d.length > 35) { return false; }

    for (let i = 0; i < d.length; i++) {
        const c = d.charCodeAt(i);
        if (s.includes(c)) xS = true;
        if (u.includes(c)) xU = true;
        if (l.includes(c)) xL = true;
        if (t.includes(c)) xD = true;
    }

    return xS && xU && xL && xD;
}
export function getImgSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/files/${name}`);
}
export function getFileSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/files/${name}`);
}
export function getFileTmpSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/tmp/${name}`);
}
export async function getBucketFileSrc(path, name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/${path}/${name}`);
}
export function DefaultLoadingLogo()
{
    return (
        <>                   
            <div className={[Style.scene].join(" ")}>
                <div    style={{width: '100%'}}
                        className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                    <div className={Style.mentor_main}>
                        <svg    xmlns="http://www.w3.org/2000/svg" 
                                viewBox="-219.9165 -219.9165 879.666 879.666"
                                style={{fill:' #fff', width: 'auto', height: '20.0rem'}} 
                        >
                            <g className={Style.mentor_arrow}>
                                <polygon points="259.164,350.396 278.696,358.185 331.142,320.003 300.912,320.003 "/> 
                                <polygon points="246.048,195.833 299.966,235.085 319.497,227.296 276.278,195.833 "/>
                                <polygon points="180.663,350.392 138.922,320.003 108.691,320.003 161.132,358.18 "/>
                                <polygon points="193.786,195.833 163.556,195.833 120.33,227.3 139.862,235.089 "/>
                            </g>
                            <g className={Style.mentor_0}> 
                                <path d="M219.927,11.558c-23.854,0-37.057,12.362-36.814,36.182c0.348,32.623,14.211,52.414,36.814,52.068 c0,0,36.802,1.492,36.802-52.068C256.729,23.918,244.294,11.558,219.927,11.558z"/>
                                <path d="M285.017,124.567l-36.77-14.659l-8.608-7.256c-2.274-1.922-5.636-1.78-7.741,0.317l-11.973,11.904l-12.008-11.907 c-2.109-2.094-5.465-2.229-7.736-0.313l-8.611,7.256l-36.77,14.661c-11.842,4.715-11.83,46.647-12.848,50.497h155.93 C296.866,171.228,296.862,129.28,285.017,124.567z"/>
                            </g> 
                            <g className={Style.mentor_1}> 
                                <path d="M77.976,228.568c0,0,36.801,1.492,36.801-52.068c0-23.82-12.434-36.182-36.801-36.182 c-23.854,0-37.057,12.362-36.814,36.182C41.509,209.124,55.372,228.915,77.976,228.568z"/>
                                <path d="M143.065,253.329l-36.77-14.658l-8.609-7.256c-2.275-1.923-5.635-1.781-7.742,0.315l-11.971,11.904l-12.008-11.908 c-2.109-2.094-5.465-2.229-7.736-0.312l-8.611,7.256l-36.77,14.66C1.006,258.045,1.018,299.977,0,303.827h155.93 C154.915,299.988,154.911,258.042,143.065,253.329z"/>
                            </g> 
                            <g className={Style.mentor_2}> 
                                <path d="M361.878,228.568c0,0,36.801,1.492,36.801-52.068c0-23.82-12.434-36.182-36.801-36.182 c-23.854,0-37.057,12.362-36.812,36.182C325.411,209.124,339.274,228.915,361.878,228.568z"/>
                                <path d="M426.968,253.329l-36.77-14.658l-8.609-7.256c-2.273-1.923-5.635-1.781-7.742,0.315l-11.971,11.904l-12.008-11.908 c-2.109-2.094-5.465-2.229-7.736-0.312l-8.61,7.256l-36.771,14.66c-11.842,4.715-11.83,46.646-12.848,50.497h155.93 C438.817,299.988,438.812,258.042,426.968,253.329z"/>
                            </g>
                            <g className={Style.mentor_3}> 
                                <path d="M219.927,264.767c-23.854,0-37.057,12.361-36.814,36.182c0.348,32.625,14.211,52.414,36.814,52.068 c0,0,36.802,1.492,36.802-52.068C256.729,277.128,244.294,264.767,219.927,264.767z"/>
                                <path d="M285.017,377.778l-36.77-14.66l-8.608-7.256c-2.274-1.922-5.636-1.78-7.741,0.316l-11.973,11.904l-12.008-11.906 c-2.109-2.096-5.465-2.229-7.736-0.313l-8.611,7.255l-36.77,14.661c-11.842,4.716-11.83,46.646-12.848,50.496h155.93 C296.866,424.437,296.862,382.489,285.017,377.778z"/> 
                            </g> 
                        </svg>  
                    </div>
                </div>
            </div>
        </>
    );
}
export function DefaultLoadingISELogo()
{
    return (
        <>                   
            <div className={[Style.scene, Style.mt_5].join(" ")}>
              <div className={[Style.sphere, Style.answer_sphere].join(" ")}></div>
            </div>
        </>
    );
}
export function DavidCopperfield(fd,d,p)
{
    let r = localStorage.getItem("Charlore");
    if (r) {      
        let data = JSON.parse(r);
        data.cap = data.cap.split("|ISE|");
        data.cap = JSON.parse(funGame(data.cap));
        for (let i = 0; i < data.cap.length; i++) {
            if (data.cap[i].feature === fd) {
                if (data.cap[i].options[p] === String.fromCharCode(d)) {
                    return true;
                }
            }
        }
    }
    return false;
}
export function Heimdall(p)
{
    let data            = localStorage.getItem("Charlore");
    data                = JSON.parse(data);
    return false;
}
export function IsMobileOrTablet() 
{
    const userAgent = navigator.userAgent || window.opera;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return /android|ipad|iphone|ipod/i.test(userAgent) || (isTouch && isSmallScreen);
}
export function SetAppLang(l) {
    localStorage.setItem("usr_app_lang", l);
}
export function GetAppLang() {
    try {
        let lang = localStorage.getItem("usr_app_lang");
        if (lang) {
            return lang;
        }
        else {
            let browserLang = (navigator.language || navigator.userLanguage).split('-')[0];
            switch (browserLang) {
                case 'pt':
                    lang = "Pt";
                    SetAppLang(lang);
                    break;
                case 'en':
                    lang = "En";
                    SetAppLang(lang);
                    break;
                case 'es':
                    lang = "Es";
                    SetAppLang(lang);
                    break;
                default:
                    lang = "Pt";
                    SetAppLang(lang);
                    break;
            }
        }
        return lang;
    }
    catch {
        SetAppLang("Pt");
        return "Pt";
    }
}
export function GetSystemLabel(key) {
    if (App_Labels) return (App_Labels.System[`${ApplicationLanguage}`][`${key}`]);
}
export function GetBusinessLabel(key) {
    if (App_Labels) return (App_Labels.Business[`${ApplicationLanguage}`][`${key}`]);
}
export function SetLastFeature(d) {
    localStorage.setItem("last_feature", d);
}
export function toSafeFilename(str) {
  const charSet = [
    ...Array.from({ length: 10 }, (_, i) => 48 + i), // 0-9
    ...Array.from({ length: 26 }, (_, i) => 65 + i), // A-Z
    95, // underscore
    ...Array.from({ length: 26 }, (_, i) => 97 + i) // a-z
  ];

  let processedString = '';

  for (let char of str) {
    let charValue = char.charCodeAt(0);

    switch (charValue) {
      case 0x2d: // -
      case 0x20: // space
        char = '_';
        charValue = 0x5f;
        break;
      case 0xc0: case 0xc1: case 0xc2: case 0xc3: // À Á Â Ã
        char = 'A';
        charValue = 0x41;
        break;
      case 0xc7: // Ç
        char = 'C';
        charValue = 0x43;
        break;
      case 0xe0: case 0xe1: case 0xe2: case 0xe3: // à á â ã
        char = 'a';
        charValue = 0x61;
        break;
      case 0xe7: // ç
        char = 'c';
        charValue = 0x63;
        break;
      case 0xf1: case 0xf3: case 0xf4: case 0xf5: // ò ó ô õ
        char = 'o';
        charValue = 0x6f;
        break;
      case 0xf9: case 0xfa: case 0xfb: // ù ú û
        char = 'u';
        charValue = 0x75;
        break;
      case 0x116: case 0x117: // Ė ė
        char = 'e';
        charValue = 0x65;
        break;
      case 0x13a: // ĺ
        char = 'i';
        charValue = 0x69;
        break;
    }

    if (charSet.includes(charValue)) {
      processedString += char;
    } else {
      processedString += '';
    }
  }
  return processedString;
}

export function IsMentor() {
    try {
        let raw_data = localStorage.getItem("Charlore");
        if (raw_data) {
            let data = JSON.parse(raw_data);
            if (data?.MenteeList?.length > 0)
                return true;
        }
    }
    catch(e) {
        console.error(e);
    }
    return false;
}
export function AppFeature(ftNumber) {
    let obj = { FeatureId: ftNumber, desc: '', path: ''};
 
    switch(ftNumber) {
        case 1:
            obj.desc = GetBusinessLabel("MenuDashboard");
            obj.path = "feedback";
            break;
        case 2:
            obj.desc = GetBusinessLabel("MenuFeedbackScript");
            obj.path = "content_script";
            break;            
        case 3:
            obj.desc = GetBusinessLabel("MenuFeedbackReport");
            obj.path = "report";
            break;
        case 4:
            obj.desc = GetBusinessLabel("MenuBind");
            obj.path = "bind_users";
            break;
        case 5:
            obj.desc = GetSystemLabel("Users");
            obj.path = "users";
            break;            
        case 6:
            obj.desc = GetSystemLabel("Contents");
            obj.path = "content";
            break;                        
        case 7:
            obj.desc = GetSystemLabel("Configurations");
            obj.path = "config";
            break;                        
        case 8:
            obj.desc = GetSystemLabel("Administration");
            obj.path = "adm";
            break;                                         
        default:
            obj.desc = "";
            obj.path = "/";
      break;
    }
    return (obj);
}
export function ValidateBusinessRulesForMenu() {
    let data            = localStorage.getItem("Charlore");
    data                = JSON.parse(data);        
    let moduleList      = {
        Block_0: [], 
        Block_1: [],
        Block_2: [],
    }
    if (data.ModuleName === "A" && IsMentor()) {
        moduleList.Block_0 = [1,2];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [8];
    }
    if (data.ModuleName === "A" && !IsMentor()) {
        moduleList.Block_0 = [];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [8];
    }
    if (data.ModuleName === "B" && !IsMentor()) {
        moduleList.Block_0 = [];
        moduleList.Block_1 = [3];
        moduleList.Block_2 = [4,5,6,7,9];
    }
    if (data.ModuleName === "B" && IsMentor()) {
        moduleList.Block_0 = [1,2];
        moduleList.Block_1 = [3];
        moduleList.Block_2 = [4,5,6,7,9];
    }
    if (data.ModuleName === "C" && !IsMentor()) {
        moduleList.Block_0 = [];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [8];
    }    
    if (data.ModuleName === "C" && IsMentor()) {
        moduleList.Block_0 = [1,2];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [8];
    }
    if (data.ModuleName === "D" && !IsMentor()) {
        moduleList.Block_0 = [];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [];
    }    
    if (data.ModuleName === "D" && IsMentor()) {
        moduleList.Block_0 = [1,2];
        moduleList.Block_1 = [];
        moduleList.Block_2 = [];
    }    
    return(moduleList);
}
export function getFeaturesPreferences() {
    const data = JSON.parse(localStorage.getItem("Charlore"));
    let list = [];

    function addValues(values) {
        values.forEach(value => {
            if (!list.includes(value)) {
                list.push(value);
            }
        });
    }

    if (data.ModuleName === "A" && IsMentor()) {
        addValues([1, 2, 8]);
    }

    if (data.ModuleName === "A" && !IsMentor()) {
        addValues([8]);
    }

    if (data.ModuleName === "B" && !IsMentor()) {
        addValues([3, 4, 5, 6, 7]);
    }

    if (data.ModuleName === "B" && IsMentor()) {
        addValues([1, 2, 3, 4, 5, 6, 7]);
    }

    if (data.ModuleName === "C" && !IsMentor()) {
        addValues([8]);
    }

    if (data.ModuleName === "C" && IsMentor()) {
        addValues([1, 2, 8]);
    }

    if (data.ModuleName === "D" && IsMentor()) {
        addValues([1]);
    }

    return list;
}
export function ValidateBusinessRules(d) {
    let data            = localStorage.getItem("Charlore");
    data                = JSON.parse(data);
    if (data.ModuleName === d) {
        return(true);
    }
    return(false);
}

export const Spinner = ({...props}) => {
    const messages = [
        GetBusinessLabel("LoadingMessage0"),
        GetBusinessLabel("LoadingMessage1"),
        GetBusinessLabel("LoadingMessage2"),
        GetBusinessLabel("LoadingMessage3"),
        GetBusinessLabel("LoadingMessage4"),
        GetBusinessLabel("LoadingMessage5"),
        GetBusinessLabel("LoadingMessage6"),
        GetBusinessLabel("LoadingMessage7"),
        GetBusinessLabel("LoadingMessage8"),
        GetBusinessLabel("LoadingMessage9"),
        GetBusinessLabel("LoadingMessage10"),
        GetBusinessLabel("LoadingMessage11"),
        GetBusinessLabel("LoadingMessage12"),
        GetBusinessLabel("LoadingMessage13"),
        GetBusinessLabel("LoadingMessage14"),
        GetBusinessLabel("LoadingMessage15"),
        GetBusinessLabel("LoadingMessage16"),
        GetBusinessLabel("LoadingMessage17"),
        GetBusinessLabel("LoadingMessage18"),
        GetBusinessLabel("LoadingMessage19"),
        GetBusinessLabel("LoadingMessage20"),
    ];    
    const [messageIndex, setMessageIndex] = useState(0);
    
    useEffect(() => {
        const changeInterval = 2500;    
        const interval = setInterval(() => {
            setMessageIndex((lastIndex) => {
                if (lastIndex < messages.length - 1) {
                    return lastIndex + 1;
                }
                return lastIndex;
            });
        }, changeInterval);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={Style.row}>
            <div  className={[Style.col, Style.d_flex, Style.flex_column, Style.align_items_center, Style.justify_content_center].join(" ")} style={props.style}>
                <div className={Style.spinner}/>
                <span className={[Style.text_body, Style.fs_9, Style.mt_1].join(" ")}>
                    {messages[messageIndex]}
                </span>
            </div>
        </div>
    );
}
export const SpinnerSmall = ({...props}) => {
    return (
        <div className={Style.row}>
            <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")} style={props.style}>
                <div className={Style.spinner_small}>
            </div>
            </div>
        </div>
    );
}
export function AppTheme() {
    try {
        return localStorage.getItem("app_theme");
    } 
    catch (e) {
        return "light";
    }
}
export function isDarkMode() {
    try {
        return localStorage.getItem("app_theme") === "dark";
    } 
    catch (e) {
        console.error("Local storage access denied:", e);
        return false;
    }
}
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}